import { Mapper } from "../../../../base/utils/mapper";
import { RetinoscopyResponseModel } from "../../../../domain/models/consult/retinoscopy-response.model";
import { RetinoscopyResponseEntity } from "../entities/retinoscopy-response.entity";



export class RetinoscopyImplementationRepositoryMapper extends Mapper<RetinoscopyResponseEntity, RetinoscopyResponseModel> {
    mapFrom(param: RetinoscopyResponseEntity): RetinoscopyResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: RetinoscopyResponseModel): RetinoscopyResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}